import React__default, { useContext } from 'react';
import { __rest, __assign } from '../../_virtual/_tslib.js';
import { Waypoint } from 'react-waypoint';
import Measure from 'react-measure';
import { TouchScrollable } from 'react-scrolllock';
import { ScrollContext } from '../../containers/Scrollable/index.js';
import classnames from 'classnames';
import styles from './styles.css.js';

var Conversation = function Conversation(_a) {
  var children = _a.children,
      loading = _a.loading,
      hasMore = _a.hasMore,
      className = _a.className,
      scrollableElementRef = _a.scrollableElementRef,
      onInfiniteLoad = _a.onInfiniteLoad,
      props = __rest(_a, ["children", "loading", "hasMore", "className", "scrollableElementRef", "onInfiniteLoad"]);

  var _b = useContext(ScrollContext),
      isScrolledToBottom = _b.isScrolledToBottom,
      scrollToTarget = _b.scrollToTarget;

  return (
    /**
     * We need to scroll to bottom when either the scroll container resizes (like when suggested actions are rendered)
     * or when the content within the scroll container changes size (messages change size or a new message is added)
     * Unfortunately, react-measure has a bug that prevents it from referencing the same element as a different ref
     * i.e. we can't do ref={scrollableElementRef(e); measureRef(e)} on just the one scroll container
     * https://github.com/souporserious/react-measure/issues/90
     */
    React__default.createElement(Measure, {
      bounds: true,
      onResize: scrollToTarget
    }, function (_a) {
      var measureRef = _a.measureRef;
      return React__default.createElement("div", {
        ref: measureRef,
        className: styles.listWrapper
      }, React__default.createElement(TouchScrollable, null, React__default.createElement("div", __assign({
        className: classnames(className, styles.messageList, styles.flat),
        ref: scrollableElementRef
      }, props), React__default.createElement(Waypoint // Offset of -400 to preload new messages when user is 400px from top of container
      , {
        // Offset of -400 to preload new messages when user is 400px from top of container
        topOffset: -400,
        scrollableAncestor: scrollableElementRef.current,
        onEnter: function onEnter() {
          // Only load more messages when:
          //
          //  - We have already loaded some messages, and more messages exist to fetch
          //  - We aren't already loading messages
          //  - We aren't scrolled to the bottom of the conversation (this prevents fetching messages on initial load)
          //  - We have a callback to fetch more messages
          if (children && !loading && hasMore && !isScrolledToBottom && onInfiniteLoad) {
            onInfiniteLoad();
          }
        }
      }), React__default.createElement(Measure, {
        bounds: true,
        onResize: scrollToTarget
      }, function (_a) {
        var measureRef = _a.measureRef;
        return React__default.createElement("div", {
          ref: measureRef
        }, children);
      }))));
    })
  );
};

export default Conversation;
//# sourceMappingURL=index.js.map
